var __jsx = React.createElement;
import React from 'react';
import { SubHeading } from "./style";
var CardSubHeading = function CardSubHeading(_ref) {
  var copy = _ref.copy;
  return __jsx(SubHeading, null, copy);
};
export default CardSubHeading;